var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.979,
    height: 15,
    viewBox: "0 0 14.979 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icons",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11988",
    "data-name": "Group 11988",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20596",
    "data-name": "Path 20596",
    d: "M19.417,11c-.083-.083-.083-.167-.167-.25l-2.5-2.5a.825.825,0,1,0-1.167,1.167L16.667,10.5H12.833a.833.833,0,0,0,0,1.667h3.833L15.583,13.25a.806.806,0,0,0,0,1.167.806.806,0,0,0,1.167,0l2.5-2.5c.083-.083.167-.167.167-.25A.92.92,0,0,0,19.417,11Z",
    transform: "translate(-4.5 -3.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20597",
    "data-name": "Path 20597",
    d: "M13.417,15.583a6.08,6.08,0,0,1-2.917.75,5.833,5.833,0,1,1,0-11.667,6.08,6.08,0,0,1,2.917.75.858.858,0,0,0,.833-1.5A8.308,8.308,0,0,0,10.5,3a7.5,7.5,0,1,0,3.75,14,.923.923,0,0,0,.333-1.167A.9.9,0,0,0,13.417,15.583Z",
    transform: "translate(-3 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.efc38cf15123b9d20dc09f6089382655.svg";
export { ForwardRef as ReactComponent };